import { CampaignTypeDefinitions, MessageMedium } from 'modules/graphql/types';
import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';
import { actionTypes as ToastsActionTypes } from 'modules/toastContainer/actionTypes';

export type CampaignGoalStats = {
  id: number;
  type: CampaignTypeDefinitions;
  name: string;
  thumbnail: string;
  messageMedium: MessageMedium;
  startedAt: string;
  contributions: number;
  revenue: number;
  sends: number;
  delivered: number;
};

export type PerformantCampaignData = {
  best: CampaignGoalStats[];
  worst: CampaignGoalStats[];
  startTime?: string;
  endTime?: string;
};
export type PerformantCampaignState = {
  data: PerformantCampaignData;
  loading: boolean;
  error: boolean;
};

export type PerformantCampaignPayload = Record<string, unknown>;

export type PerformantCampaignAction<T = Record<string, unknown>> = {
  type: ActionTypes | ToastsActionTypes;
  payload?: PerformantCampaignPayload;
} & T;

export type PerformantCampaignQuery = {
  goalName: string;
  count: number;
  startTime?: string;
  endTime?: string;
};

export enum PerformantCampaignVariant {
  BEST = 'best',
  WORST = 'worst',
}
